import React from "react";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import { PeekDialog } from "@piiqtechnologies/ui-components";
import { CreateOrEditUserForm } from "@components/users/create-or-edit-user-form";
export const AddUserForm = ({ onClose, handleInfoUpdate }) => {
    const intl = useIntl();
    const handleSubmit = () => {
        onClose();
        handleInfoUpdate();
    };
    return (React.createElement(PeekDialog, { disablePortal: true, maxWidth: "sm", hasCloseIcon: true, fullWidth: true, title: intl.formatMessage(messages.addUserTitle), open: true, onClose: onClose },
        React.createElement(CreateOrEditUserForm, { isUserCreation: true, isAdminForm: true, onSubmit: () => handleSubmit() })));
};
export default AddUserForm;
